import { fetchData } from './fetch';
import { checkResponseData, handleMaintenancePopup, setMaintenanceInfo } from './maintenance';

export const checkSelectedCity = async () => {
  const selectedCity = document.querySelectorAll('.location-picker')[0];

  if (!selectedCity) return;

  const { cityname: cityName, cityid: cityId, page } = selectedCity.dataset;


  const response = await fetchData(`/v1/maintenance/enabled?cityId=${cityId}`);

  if (checkResponseData(response.data)) {
    setMaintenanceInfo(
      response.data.title,
      response.data.text,
      response.data.imageUrl,
    );
    handleMaintenancePopup(cityId, cityName, page);
  }

  localStorage.setItem('isContentAvailable', false);
};
